module.exports = __webpack_public_path__ + "static/img/business1.ef67de4.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/business1.png
// module id = weA3
// module chunks = 1